import React from 'react';
import { observer, inject } from 'mobx-react';
import {
  withStyles,
  Grid,
  Typography,
  Button,
  FormControl,
  Paper,
  RadioGroup,
  Radio,
  FormControlLabel,
} from '@material-ui/core';
import * as Icons from '@material-ui/icons';
import Swal from 'sweetalert2';
import { withTranslation } from 'react-i18next';
import { saveAs } from 'file-saver';
import SelectTenant from '../../components/Select/SelectTenant';
import { setSelectTenant } from '../../utils/common';
import { getToken } from '../../components/Token';
import { getTenantHeaders } from '../../components/TenantHeaders';
import config from '../../config';
import CalendarDate from '../summaryReport/components/DatePicker/CalendarDate';
import Buttonbar from './components/Buttonbar';
import FixedEmergencyDevice from './components/Chart/FixedEmergencyDeviceChart';

class FixedButtonUsageSummary extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      tenant: '',
      timeRange: 'week',
      date: new Date().toDateString(),
      type: 'location',
    };
  }

  async componentDidMount() {
    const tenantIds = localStorage.getItem('select_tenant') ? [+localStorage.getItem('select_tenant')] : [];
    this.setState({
      tenant: JSON.stringify(tenantIds),
    });
    const { timeRange, date, type } = this.state;
    await this.props.usageSummary.getFixedEmergencySummary(new Date(date), JSON.stringify(tenantIds), timeRange, type);
  }

  onDateChange = async (value) => {
    const { timeRange, tenant, type } = this.state;
    const newDate = value.toDateString();
    if (this.state.date === newDate) {
      return;
    }
    this.setState({
      date: value.toDateString(),
    });

    await this.props.usageSummary.getFixedEmergencySummary(value, tenant, timeRange, type);
  };

  titleContent() {
    const { classes } = this.props;
    const { date } = this.state;
    return (
      <div className={classes.titleBar}>
        <Grid className={classes.wrapCalendar}>
          <CalendarDate date={date} onDateChange={this.onDateChange} InputStyle={classes.dateInput} />
        </Grid>
      </div>
    );
  }

  handleChangeTenant = async (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });

    const tenantIds = JSON.parse(value);
    setSelectTenant(tenantIds);

    const { timeRange, date, type } = this.state;
    const ids = tenantIds ? JSON.stringify(tenantIds) : '[]';
    await this.props.usageSummary.getFixedEmergencySummary(new Date(date), ids, timeRange, type);
  };

  handleDownloadCSV() {
    const { classes } = this.props;
    return (
      <div className={classes.wrapBtncsv}>
        <Button
          color='primary'
          variant='contained'
          className={classes.btncsv}
          id='download'
          onClick={this.onSubmitExportCSV}
          disabled
        >
          <Icons.GetApp />
          CSV
        </Button>
      </div>
    );
  }

  onSubmitDownloadCSV = async () => {
    await this.props.device.getUsageSummaryCSV();
  };

  onSubmitExportCSV = () => {
    const tenantId = 1;
    const startDate = '2022-11-13';
    const endDate = '2022-11-14';

    const params = new URLSearchParams({ tenantId, startDate, endDate });

    let url = `${config.api.url}/${config.api.version}/device/usagesummary/csv?${params}`;

    console.log(url);
    try {
      fetch(url, {
        method: 'GET',
        headers: {
          ...getTenantHeaders(),
          Authorization: 'Bearer ' + getToken('id_token'),
        },
      })
        .then(function (response) {
          if (response.status === 200) {
            return response.blob();
          } else {
            Swal.fire({
              html: `<h4>ไม่มีข้อมูล`,
              type: 'error',
            });
          }
        })
        .then(function (blob) {
          if (blob) {
            console.log('blob: ', blob);
            saveAs(blob, `usagesummary.zip`);
          }
        });
    } catch (err) {
      Swal.fire({
        html: `<h4>ไม่มีข้อมูล`,
        type: 'error',
      });
    }
  };

  onChangePeriod = async (timeRange) => {
    this.setState({ timeRange });
    const { date, type, tenant } = this.state;
    await this.props.usageSummary.getFixedEmergencySummary(new Date(date), tenant, timeRange, type);
  };

  onChangeType = async (e) => {
    const { value } = e.target;
    this.setState({ type: value });
    const { timeRange, date, tenant } = this.state;
    await this.props.usageSummary.getFixedEmergencySummary(new Date(date), tenant, timeRange, value);
  };

  render() {
    const { t, classes } = this.props;
    const { timeRange, type, date } = this.state;
    const { summaryFixedDevice } = this.props.usageSummary.toJS();

    const tmp = (
      <React.Fragment>
        <div className={classes.pageTitleContainer}>
          <Grid container item xs={12} sm={12} md={12} lg={4} xl={4}>
            <Typography className={classes.headTitle}>{t('fixed_button')}</Typography>
            <div className={classes.titleBar}>
              <SelectTenant handleChangeTenant={this.handleChangeTenant} tenant={this.state.tenant} />
            </div>
          </Grid>
          <Grid item xs={8} sm={8} md={8} lg={6} xl={6}>
            {this.titleContent()}
          </Grid>
          <Grid item xs={2} sm={2} md={4} lg={2} xl={2}>
            {this.handleDownloadCSV()}
          </Grid>
        </div>
        <Grid className={classes.mainContain} spacing={32} container>
          <Grid item sm={12}>
            <Paper className={classes.gridContent}>
              <Grid container item xs={12} sm={8} md={8} alignItems='center'>
                <Buttonbar onChangePeriod={this.onChangePeriod} viewType={timeRange} t={t} />
              </Grid>

              <Grid container item xs={12} md={4} alignItems='center' justify='flex-end'>
                <FormControl component='fieldset'>
                  <RadioGroup
                    aria-label='filterType'
                    id='filterType'
                    name='filterType'
                    value={type}
                    onChange={(e) => this.onChangeType(e)}
                    row
                  >
                    <FormControlLabel
                      value={'location'}
                      control={<Radio id='Location' color='primary' />}
                      label={t('location')}
                    />
                    <FormControlLabel
                      value={'device'}
                      control={<Radio id='device' color='primary' />}
                      label={t('device')}
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Paper>
          </Grid>

          <Grid item xs={12} style={{ paddingTop: 4 }}>
            <Paper className={classes.paperList}>
              {summaryFixedDevice.map((summary, i) => (
                <FixedEmergencyDevice
                  key={i}
                  t={t}
                  data={summary.data}
                  date={date}
                  onChangePeriod={this.onChangePeriod}
                  viewType={timeRange}
                  tenantName={summary.tenantName}
                  totalSummary={summary.total || 0}
                />
              ))}
            </Paper>
          </Grid>
        </Grid>
      </React.Fragment>
    );
    return tmp;
  }
}

const styles = (theme) => ({
  mainContain: {
    marginTop: '5px',
    padding: 16,
  },
  btncsv: {
    border: 'none',
    backgroundColor: '#E5F0F6',
    cursor: 'pointer',
    height: '38px',
    '&:hover': {
      border: 'none',
      backgroundColor: '#E5F0F6',
    },
  },
  wrapBtncsv: {
    marginTop: '5px',
    [theme.breakpoints.up('md')]: {
      textAlign: 'right',
      marginTop: 0,
    },
  },
  titleBar: {
    display: 'flex',
    marginTop: '-5px',
  },
  wrapCalendar: {
    display: 'flex',
    // width: "520px",
    marginTop: 6,
  },
  wrapButton: {
    marginLeft: 18,
    marginTop: 4,
    display: 'flex',
  },
  paperList: {
    overflowX: 'auto',
    padding: '10px 20px',
    boxShadow: '0px 4px 34px rgba(0, 0, 0, 0.06)',
    maxHeight: '72vh',
  },
  tableCell: {
    color: theme.palette.text.header,
    borderBottom: '1px solid #B8CFC3',
    padding: '4px',
  },
  headTable: {
    border: 'none',
  },
  bodyTable: {
    borderTop: '1px solid #B8CFC3',
  },
  bgIcon: {
    backgroundColor: theme.palette.primary.bg,
    width: 80,
    height: 80,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 4,
    margin: 8,
  },
  styleIcon: {
    color: theme.palette.success.main,
    width: 55,
    height: 55,
  },
  gridContent: {
    position: 'relative',
    boxShadow: '0px 4px 34px rgba(0, 0, 0, 0.06)',
    overflow: 'hidden',
    padding: '10px 25px',
    display: 'flex',
  },
  wrapContent: {
    margin: 8,
    textAlign: 'center',
  },
  contentTitle: {
    fontSize: 20,
    fontWeight: 600,
    color: theme.palette.text.secondary,
  },
  contentSubTitle: {
    fontSize: 36,
    fontWeight: 600,
    color: theme.palette.text.primary,
  },
  noDataBox: {
    textAlign: 'center',
    fontSize: 18,
    fontWeight: 600,
    color: theme.palette.text.header,
  },
  pageTitleContainer: {
    background: 'white',
    margin: '-24px',
    padding: '36px 40px 7px 40px',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  headTitle: {
    color: theme.palette.text.header,
    fontSize: '24px',
    padding: '4px',
    fontWeight: 500,
    marginRight: 30,
    [theme.breakpoints.down('sm')]: {
      fontSize: '20px',
    },
  },
  button: {
    boxShadow: theme.customShadows.widget,
    textTransform: 'none',
    '&:active': {
      boxShadow: theme.customShadows.widgetWide,
    },
  },
  dateInput: {
    '& fieldset': {
      top: '-6px',
      bottom: '2px',
    },
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    maxWidth: '100%',
  },
});

export const page = inject('usageSummary')(observer(FixedButtonUsageSummary));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
